/** Depolama ve zamanlayıcı bağımlılıkları dışarıdan verilir; DOM gerektirmez. */
export interface SolMenuDurumu { sabit: boolean }
export const SABIT_ANAHTAR = 'crm.solmenu.sabit';
type Depo = Pick<Storage, 'getItem' | 'setItem'>;
export const ilkSolMenuDurumu = (): SolMenuDurumu => ({ sabit: false });
export function solMenuOku(depo: () => Depo | undefined): SolMenuDurumu {
  try {
    const d = depo();
    const sabit = d?.getItem(SABIT_ANAHTAR);
    return { sabit: sabit === 'true' };
  } catch { return ilkSolMenuDurumu(); }
}
export function solMenuYaz(durum: SolMenuDurumu, depo: () => Depo | undefined): void {
  try {
    const d = depo();
    d?.setItem(SABIT_ANAHTAR, String(durum.sabit));
  } catch { /* Depolama kapalıysa gezinme çalışmayı sürdürür. */ }
}
export function sabitDegistir(durum: SolMenuDurumu): SolMenuDurumu {
  return { sabit: !durum.sabit };
}
export function hoverNiyeti<T>(kur: (is: () => void, ms: number) => T, sil: (id: T) => void) {
  let bekleyen: T | undefined;
  const iptal = () => { if (bekleyen !== undefined) sil(bekleyen); bekleyen = undefined; };
  const planla = (ms: number, is: () => void) => {
    iptal();
    bekleyen = kur(() => { bekleyen = undefined; is(); }, ms);
  };
  return { gir: (is: () => void) => planla(300, is), cik: (is: () => void) => planla(250, is), iptal };
}
